import React from "react";
import { styled } from '@mui/material/styles';
import { 
    Button, Typography, Table, TableBody, TableContainer,
    TableHead, TableRow, Paper, TablePagination, Grid,
    IconButton,
    Collapse
} from "@mui/material";
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { DeleteForeverOutlined, EditOutlined, KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import helpers from "../../../Helpers/Helpers";
import moment from "moment";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

export default function PermitsView(props) {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
  
    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(+event.target.value);
      setPage(0);
    };
    
    return (
      <Grid container spacing={3} sx={{placeContent: "center", py: 2}}>
        <Grid item xs={6}>
          <Typography variant="subtitle1" color="primary" className="font-bold font-gray">{props.literals.permits}</Typography>
        </Grid>
        <Grid item xs={6} align="right">
          <Button 
              type="button"
              variant="contained"
              color="primary"
              sx={{minWidth:110}}
              onClick={props.setOpenDrawer}
          >
            {props.literals.add} +
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Paper elevation={0} sx={{ width: '100%', overflow: 'hidden' }}>
              <TableContainer sx={{ height: '65vh' }}>
                  <Table aria-label="collapsible table" size="small">
                      <TableHead>
                          <TableRow>
                              <StyledTableCell></StyledTableCell>
                              <StyledTableCell>{props.literals.organization}</StyledTableCell>
                              <StyledTableCell>{props.literals.zone_name}</StyledTableCell>
                          </TableRow>
                      </TableHead>
                      <TableBody>
                          {props.permits
                          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          .map((row) => {
                            
                              return (
                                  <>
                                      <TableRow key={row.zone_name}>
                                        <TableCell>
                                              <IconButton
                                                  aria-label="expand row"
                                                  size="small"
                                                  onClick={() => {
                                                      if(props.open !== row._id){props.getDetail(row)};
                                                      props.setOpen((row._id === props.open ? "" : row._id))
                                                  }}
                                              >
                                                  {props.open === row._id ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                                              </IconButton>
                                          </TableCell>
                                          <TableCell>{row.organization[0].org_name}</TableCell>
                                          <TableCell>{row.zone_name}</TableCell>
                                      </TableRow>
                                      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                                          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
                                              <Collapse in={props.open === row._id} timeout="auto" unmountOnExit>
                                                  {props.permitDetail.length>0 && <Paper elevation={1} sx={{ margin: 1 }}>
                                                    <Table size="small">
                                                      <TableHead>
                                                        <TableRow>
                                                            <StyledTableCell> {props.literals.permit_type}</StyledTableCell>
                                                            <StyledTableCell> {props.literals.permit_name}</StyledTableCell>
                                                            <StyledTableCell> {props.literals.permit_start_date}</StyledTableCell>
                                                            <StyledTableCell> {props.literals.permit_end_date}</StyledTableCell>
                                                            <StyledTableCell> {props.literals.renew_before}</StyledTableCell>
                                                            <StyledTableCell> {props.literals.no_of_months_years}</StyledTableCell>
                                                            <StyledTableCell> {props.literals.auto_renew_permission}</StyledTableCell>
                                                            <StyledTableCell> {props.literals.rate}</StyledTableCell>
                                                            <StyledTableCell> {props.literals.enable_permit_limit}</StyledTableCell>
                                                            <StyledTableCell> {props.literals.no_of_permits_allowed}</StyledTableCell>
                                                            <StyledTableCell> {props.literals.action}</StyledTableCell>
                                                        </TableRow>
                                                      </TableHead>
                                                      {props.permitDetail.map(x=>{
                                                        return(
                                                          <TableBody>
                                                            <TableRow>
                                                                <TableCell>{x.permit_type}</TableCell>
                                                                <TableCell>{x.permit_name}</TableCell>
                                                                <TableCell>{x.permit_start_date ? moment(x.permit_start_date).format('MMM/DD/YYYY') : '--' }</TableCell>
                                                                <TableCell>{x.permit_start_date ? moment(x.permit_end_date).format('MMM/DD/YYYY') : '--' }</TableCell>
                                                                <TableCell>{x.renew_before}</TableCell>
                                                                <TableCell>{x.permit_type !== 'custom' ? x.no_of_months_year : '--'}</TableCell>
                                                                <TableCell>{x.auto_renew_permission ? props.literals[x.auto_renew_permission] : '--'  }</TableCell>
                                                                <TableCell>${(x.rate/100).toFixed(2)}</TableCell>
                                                                <TableCell>{x.enable_permit_limit ? 'Yes' : 'No'}</TableCell>
                                                                <TableCell>{x.enable_permit_limit ? x.no_of_permits_allowed : '--'}</TableCell>
                                                                <TableCell >
                                                                  <Button 
                                                                      type="button" 
                                                                      onClick={()=>props.delItem(x._id)} 
                                                                      disabled={helpers.abilityByModuleKey('rates').can_delete == false}
                                                                      sx={{color: '#bc0000', background: '#bc00002e', p: '2px', minWidth: 0, m: 1}}
                                                                  >
                                                                      <DeleteForeverOutlined />
                                                                  </Button>
                                                                  <Button
                                                                      type="button" 
                                                                      disabled={helpers.abilityByModuleKey('rates').can_edit == false}
                                                                      onClick={()=>{props.onEdit(x)}}
                                                                      sx={{color: '#027c92', background: '#027c924d', p: '2px', minWidth: 0, m: 1}}
                                                                  >
                                                                      <EditOutlined/>
                                                                  </Button>
                                                              </TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                        )
                                                      })}
                                                    </Table>
                                                  </Paper>}
                                              </Collapse>
                                          </TableCell>
                                      </TableRow>
                                  </>
                              );
                          })}
                      </TableBody>
                  </Table>
              </TableContainer>
              <TablePagination
                  rowsPerPageOptions={[10, 25, 100, { label: 'All', value: props.permits.length }]}
                  component="div"
                  count={props.permits.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  SelectProps={{
                      MenuProps: { classes: "selectDropdown" }
                  }}
              />
          </Paper> 
        </Grid>
      </Grid>
    );
}
